import qs from 'qs'
import { fetchRest } from '@/lib/hook/tanstackQuery'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'
import {
  buildSearchParams,
  formatSearchResult,
  SearchProductsArgs,
} from '@/lib/searchProductsTransform'

// Appel REST + transfo reproduisant le resolver searchProducts (lot 7).
// Remplace les useQuery Apollo (SEARCH_PRODUCTS / SEARCH_PRODUCTS_FACET) dans
// useSearchProduct.ts. L'etat des filtres est lu depuis l'URL (query-params)
// via useSearchState (lot 2).
//
// On serialise les params avec qs.stringify (comme le resolver via
// callCsCartApi paramsSerializer) pour reproduire fidelement la query string
// CS-Cart : filter_variants[...]=, also_bought_for_product_ids[]=, etc. On
// passe l'endpoint complet a fetchRest (queriesParams non utilise, car
// appendQueryParams ne gere pas les objets imbriques).
export const fetchSearchProducts = async (
  args: SearchProductsArgs,
  options?: { locale?: string; baseUrl?: string }
): Promise<any> => {
  const params = buildSearchParams(args)
  const queryString = qs.stringify(params)
  // L'endpoint de base provient de ApiQueryEndpoint (SEARCH_PRODUCTS_FACET pour
  // l'appel facettes get_only_filters, SEARCH_PRODUCTS sinon). Les deux ciblent
  // `products` cote CS-Cart ; la query string porte la difference.
  const baseEndpoint = args.getFilters
    ? ApiQueryEndpoint.CATALOG.SEARCH_PRODUCTS_FACET.endpoint
    : ApiQueryEndpoint.CATALOG.SEARCH_PRODUCTS.endpoint
  const endpoint = queryString ? `${baseEndpoint}?${queryString}` : baseEndpoint
  const result = await fetchRest<any>({
    endpoint,
    locale: options?.locale,
    baseUrl: options?.baseUrl,
  })
  return formatSearchResult(result, !!args.getFilters)
}

// Cle de cache TanStack. On serialise les args qui pilotent l'appel reseau.
export const searchProductsQueryKey = (
  variant: 'searchProducts' | 'searchProductsFacet',
  args: SearchProductsArgs
) => [variant, args] as const
